import type { FilterEntityIdSet } from '../../../types/filter-entity-id-set'
import type { ShopConfig } from '../shop/types'

export type ShopState = {
  filterEntityIds: FilterEntityIdSet,
  shopConfig: ShopConfig
}

const state: ShopState = {
  filterEntityIds: {
    customerGroups: [],
    productCollections: [],
    modalities: [],
    regions: [],
    salesChannels: [],
    products: [],
    terms: []
  },
  shopConfig: {
    salesChannelIds: [],
    includeClearAllFilterButton: true,
    overviewFilterTypes: [],
    overviewRoute: 'ProductOverview',
    paymentRoute: 'Payment',
    mixedShopError: {
      link: 'ProductOverview',
      message: 'mixed-shop-items-flow'
    },
    paymentMethods: [],
    type: 'NAL'
  }
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/shop/state.js